import { render, staticRenderFns } from "./filters-section.vue?vue&type=template&id=1cd678e6&scoped=true&"
import script from "./filters-section.vue?vue&type=script&lang=js&"
export * from "./filters-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd678e6",
  null
  
)

export default component.exports